// Multi-select component — manages ctrl/shift click selection on lists
// Usage: window.multiSelect = MultiSelect({ container: '.tasks-list', itemSelector: '.task-mini-card', idAttr: 'data-task-id' })

function MultiSelect(opts) {
  var containerSel = opts.container || '.tasks-list';
  var itemSel = opts.itemSelector || '[data-id]';
  var idAttr = opts.idAttr || 'data-id';
  var selectedClass = opts.selectedClass || 'selected-task';

  var state = {
    selectedIds: new Set(),
    lastClickedIndex: null,

    _getItems: function () {
      var items = [];
      document.querySelectorAll(containerSel).forEach(function (c) {
        Array.prototype.push.apply(items, Array.from(c.querySelectorAll(itemSel)));
      });
      return items;
    },

    select: function (id, node, ctrlKey, shiftKey) {
      var items = this._getItems();
      var idx = items.findIndex(function (el) { return el.getAttribute(idAttr) == id; });
      if (idx === -1) return;

      if (shiftKey && this.lastClickedIndex !== null) {
        var start = Math.min(this.lastClickedIndex, idx);
        var end = Math.max(this.lastClickedIndex, idx);
        for (var i = start; i <= end; i++) {
          items[i].classList.add(selectedClass);
          this.selectedIds.add(items[i].getAttribute(idAttr));
        }
      } else if (ctrlKey) {
        if (this.selectedIds.has(id)) {
          this.selectedIds.delete(id);
          node.classList.remove(selectedClass);
        } else {
          this.selectedIds.add(id);
          node.classList.add(selectedClass);
        }
        this.lastClickedIndex = idx;
      } else {
        items.forEach(function (el) { el.classList.remove(selectedClass); });
        node.classList.add(selectedClass);
        this.selectedIds = new Set([id]);
        this.lastClickedIndex = idx;
      }
    },

    syncUi: function () {
      var self = this;
      this._getItems().forEach(function (el) {
        var id = el.getAttribute(idAttr);
        if (self.selectedIds.has(id)) el.classList.add(selectedClass);
        else el.classList.remove(selectedClass);
      });
    },

    clear: function () {
      this.selectedIds = new Set();
      this.lastClickedIndex = null;
      this.syncUi();
    },

    getSelected: function () {
      return Array.from(this.selectedIds);
    }
  };

  return state;
}

window.MultiSelect = MultiSelect;
